import React from 'react';
import CalendarIcon from '@material-ui/icons/EventTwoTone';
import PPRSummary from '../../../components/PPRSummary';
import Promise from 'bluebird';
import { AmplifyModelContext } from 'amplify-model-react';
import GetPeriodPlanResultQuery from '../../../common/graphql/GetPeriodPlanResult';
import { useQuery } from 'react-apollo-hooks';
import get from 'lodash/get';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import compact from 'lodash/compact';
import { MemberDetailsContext } from './MemberDetails';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import DashboardContext from '../../../contexts/DashboardContext';
import subWeeks from 'date-fns/subWeeks';
import { formatAWSDate } from '../../../common/modules';
import gql from 'graphql-tag';
import sortBy from 'lodash/sortBy';
import { Map, List } from 'immutable';
import PerformanceChart from '../../../components/PerformanceChart';
import Zoom from '@material-ui/core/Zoom';

import { Timeline, TimelineEvent } from 'react-event-timeline';

import PeriodLabel from '../../../components/PeriodLabel';
import useMemberPprs from '../../../hooks/useMemberPprs';
import { useInView } from 'react-intersection-observer';

const usePeStyles = makeStyles(() => ({
  timeline: {
    '& > div:first-child': {
      background: 'lightgrey !important',
    },
  },
  event: {},
  icon: {},
}));

function PeriodEvent(props) {
  const { ppr } = props;
  const [ref, inView] = useInView({});

  const [{ success, failed }, setState] = React.useState({
    success: false,
    failed: false,
  });

  const onFailed = React.useMemo(() => {
    setState({ failed: true });
  }, [setState]);
  const onPositive = React.useCallback(() => {
    setState({ success: true });
  }, []);

  const iconColor = success ? '#6fba1c' : failed ? 'darkgrey' : 'lightgrey';

  return (
    <TimelineEvent
      title={
        <Typography variant="button">
          <PeriodLabel period={ppr.period} />
        </Typography>
      }
      iconColor={iconColor}
      icon={
        <Zoom in={inView} style={{ transitionDelay: inView ? '500ms' : '0ms' }}>
          <CalendarIcon />
        </Zoom>
      }
    >
      <div ref={ref}>
        {!ppr.id ? (
          <span>No results</span>
        ) : (
          <PPRSummary ppr={ppr} onFailed={onFailed} onPositive={onPositive} />
        )}
      </div>
    </TimelineEvent>
  );
}

const PeriodEvents = React.memo(props => {
  const { pprs } = props;
  const classes = usePeStyles();
  return (
    <Timeline className={classes.timeline}>
      {pprs.map((ppr, ii) => {
        return <PeriodEvent key={ii} ppr={ppr} />;
      })}
    </Timeline>
  );
});

const PerformanceTab = React.memo(props => {
  const { member: memberProp, period: periodProp, classes } = props;
  const mdCtx = React.useContext(MemberDetailsContext);
  const [mbrDetailState = Map({})] = mdCtx || [];
  const { state: dashboardState } = React.useContext(DashboardContext);
  const period = periodProp || get(dashboardState, 'context.currentPeriod', {});
  const [state, setState] = React.useState({ timeline: [] });
  const member = mbrDetailState.get('member') || memberProp;
  const swipeableActions = mbrDetailState.get('swipeableActions');
  console.log('>>MyTeamPage/PerformanceTab::', 'periodProp', periodProp); //TRACE
  const fromDate = React.useMemo(() => {
    if (period) return new Date(period.dateFrom);
    return new Date();
  }, [period]);
  const { periodMap, periods, errors } = useMemberPprs({ id: member.id, fromDate });
  console.log('>>MyTeamPage/PerformanceTab::', 'periods, periodMap', periods, periodMap); //TRACE

  React.useEffect(() => {
    if (!periods) return;
    const timeline = periods.map(period => {
      return get(periodMap, [period.id, 0], { period });
    });
    setState(oldState => ({ ...oldState, timeline }));
  }, [periodMap, periods]);
  const pprs = get(state, 'timeline', []);
  console.log('>>MyTeamPage/PerformanceTab::', 'pprs', pprs); //TRACE
  React.useLayoutEffect(() => {
    if (!swipeableActions) return;
    Promise.delay(500).then(() => {
      swipeableActions.updateHeight();
    });
  }, [state]);
  return (
    <div className={classes.root}>
      <Typography variant="h6">
        {member.firstName} {member.lastName} - Last 8 Weeks
      </Typography>
      <center>
        <PerformanceChart pprs={pprs} />
      </center>
      <Typography variant="h6">Timeline</Typography>
      <Divider />
      <PeriodEvents pprs={pprs} />
      {/* //   return (<div>
             
      //   </div>)
      //   if (!ppr.id)
      //     return <div key={ii}>no result for {get(ppr, 'period.name', '')}</div>;
      //   return <PPRSummary key={ppr.id} ppr={ppr} />;
      // })} */}
    </div>
  );
});

const styles = theme => ({
  root: { ...theme.typography, minHeight: 500 },
});

export default withStyles(styles)(PerformanceTab);
